import React from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import facebook from "../../images/home/client/facebook.svg";

const SlogenCarousel = {
  nav: false,
  loop: true,
  margin: 40,
  dots: false,
  autoplay: true,
  autoplaySpeed: 1000,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    576: {
      items: 2,
    },
    992: {
      items: 2,
    },
  },
};

const slogenData = [
    {
      images: facebook,
      name: "Gallup's State of the American Workplace",
      position: "A report by",
      text: "Gallup’s research shows that remote work environments lead to more motivated and engaged employees, resulting in better service delivery and output for clients.",
      points: [
        "Improved service quality",
        "Stronger employee focus benefits clients",
        "Faster response through flexibility"
      ],
    },
    {
      images: facebook,
      name: "Emily Courtney",
      position: "By",
      text: "Remote workers report higher happiness and job satisfaction, which translates to better communication, consistency, and outcomes for clients.",
      points: [
        "Better client interaction",
        "Higher consistency and delivery",
        "Stronger commitment to client success"
      ],
    },
    {
      images: facebook,
      name: "Mercer study",
      position: "By",
      text: "70% of companies are adopting hybrid models, enabling client-facing teams to work more flexibly and efficiently, without compromising service quality.",
      points: [
        "Faster project turnarounds",
        "Continued support with hybrid teams",
        "Better service adaptability"
      ],
    },
    {
      images: facebook,
      name: "Shine Infosoft",
      position: "By",
      text: "Shine Infosoft’s remote dedicated resources help clients boost productivity, reduce costs, and get faster results through flexible engagement models.",
      points: [
        "Time and cost savings for clients",
        "Scalable, dedicated resources",
        "Improved turnaround time",
        "On-demand expertise",
        "Seamless communication with remote teams"
      ],
    }

];

const Slogen = () => {
  return (
    <>
      <section className="slogenSection">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-md-3">
              <div className="heading">
                <h2 data-aos="slide-right">
                  Smarter teams. <span>Anywhere, Anytime.</span>
                </h2>
                <i className="fa fa-quote-left" />
              </div>
            </div>
            <div className="col-md-8 ml-auto">
              <OwlCarousel
                className="owl-carousel owl-theme"
                {...SlogenCarousel}
              >
                {slogenData.map((m) => (
                  <div className="item" key={m.name}>
                    <div className="details" data-aos="zoom-in">
                      <div className="head">
                        <div className="row align-items-center">
                          <div className="col-md-12 col-sm-12 col-12">
                            {/* <p>{m.position}</p> */}
                            <h5>
                              {m.position} <span>{m.name}</span>
                            </h5>
                          </div>
                          {/* <div className='col-md-4 col-sm-4 col-4'>
                                                        <img src={m.images} alt="Mobile App Development" />
                                                    </div> */}
                        </div>
                      </div>
                      <div className="text">
                        <p>{m.text}</p>
                        <ul>
                          {m.points.map((s) => (
                            <li key={s}>
                              <span>{s}</span>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Slogen;
